export function ViewLiveLink(props: { href: string | null | undefined; label?: string }) {
  if (!props.href) return null;
  return (
    <a
      href={props.href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-xs font-medium text-emerald-700 hover:text-emerald-800 whitespace-nowrap inline-flex items-center gap-0.5"
      onClick={(e) => e.stopPropagation()}
    >
      {props.label ?? "View live"} ↗
    </a>
  );
}

export function AdminListingLink(props: { href: string | null | undefined }) {
  if (!props.href) return null;
  return (
    <a
      href={props.href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-xs font-medium text-slate-500 hover:text-slate-700 whitespace-nowrap"
      onClick={(e) => e.stopPropagation()}
    >
      Admin
    </a>
  );
}
